import type { AgentPatch, EntityMetadataPatch, SlateOpsPatch } from '@tunasong/agent-tools'
import type { TunaEditor } from '@tunasong/plugin-lib'
import type { Entity } from '@tunasong/schemas'

type EditorOperation = Parameters<TunaEditor['apply']>[0]

export const applySlateOps = (editor: TunaEditor, patch: SlateOpsPatch) => {
  for (const op of patch.ops) {
    editor.apply(op as unknown as EditorOperation)
  }
}

export const buildMetadataUpdate = (patch: EntityMetadataPatch): Partial<Entity> => ({ ...patch.fields })

export interface ApplyProposalDeps {
  editor?: TunaEditor | null
  updateEntity: (entityId: string, partialEntity: Partial<Entity>) => void
}

export const applyProposal = (
  proposal: { targetEntityId: string; patch: AgentPatch },
  deps: ApplyProposalDeps
) => {
  const { patch } = proposal
  if (patch.kind === 'slate-ops') {
    if (!deps.editor) {
      throw new Error('Cannot apply slate-ops proposal: editor is not mounted')
    }
    if (deps.editor.rootElement?.id && deps.editor.rootElement.id !== proposal.targetEntityId) {
      throw new Error(
        `Proposal targets entity ${proposal.targetEntityId} but editor has ${deps.editor.rootElement.id}`
      )
    }
    applySlateOps(deps.editor, patch)
    return
  }
  if (patch.kind === 'entity-metadata') {
    deps.updateEntity(proposal.targetEntityId, buildMetadataUpdate(patch))
    return
  }
  const exhaustive: never = patch
  throw new Error(`Unknown patch kind: ${JSON.stringify(exhaustive)}`)
}
